import { Component, OnDestroy, OnInit } from '@angular/core';
import { ParamApplication, Person, QResult } from '../../../../models';
import { PlanningFormationModel } from '../../../../models/formation';
import { PlanningOnglet } from '../../../../models/formation/planning.model';
import { CoreService, HttpService } from '../../../../services';
import { StageService } from '../services/stage-modal.service';
import { PlanningService } from './planning.service';
import { Toast, ToastService } from '../../../../toast';

@Component({
  selector: 'queoval-stage-planning',
  templateUrl: './planning.component.html',
  styleUrls: ['./planning.component.css'],
  providers: [PlanningService]
})

export class PlanningComponent implements OnInit, OnDestroy {
  constructor(
    public stageService: StageService,
    public planningService: PlanningService,
    private toast: ToastService,
    private http: HttpService,
    private indParam: CoreService,
  ) { }

  ngOnDestroy(): void {
    this.planningService.ngOnDestroy();
  }

  public reservationsReady: boolean;

  public PlanningOnglet: typeof PlanningOnglet = PlanningOnglet;

  public isLoading: boolean = false;

  public isApiSoWeSignExist: boolean = false;
  public soWeSignURL: string = "";
  public soWeSignURLportail: ParamApplication = new ParamApplication('URL_PORTAIL', 'SOWESIGN');
  public soWeSignQueovalSiteWS: ParamApplication = new ParamApplication('API_REDIRECT', 'SOWESIGN');

  public isCustomGrid: boolean = false; // (true = customGrid)

  public tabs: Array<{ Type: PlanningOnglet, Name: string, Active: boolean, Visible: boolean, Locked: boolean }> = [
    { Active: true, Locked: false, Visible: true, Name: 'Planning', Type: PlanningOnglet.Planning },
    { Active: false, Locked: false, Visible: true, Name: 'Suivi des présences', Type: PlanningOnglet.SuiviPresence }
  ];

  public ActiveTab(indexType: number): void {
    this.tabs.forEach(tab => {
      if (tab.Type === indexType && tab.Visible && !tab.Locked) {
        tab.Active = true;
        this.planningService.View = tab.Type;        
      }
      else tab.Active = false;
    });
    if (this.tabs.findIndex(t => t.Active) === -1) this.tabs[0].Active = true;

    this.planningService.OnRefreshDisplay();
  }

  public ngOnInit(): void {
    this.reservationsReady = false;
    this.planningService.View = PlanningOnglet.Planning;
    this.isCustomGrid = false;
    this.planningService.isSelectAll = false;
    this.isLoading = true;
    // Récupération des infos du stage pour les filtres + la liste des réservations du stage
    this.http.getHttp<QResult<PlanningFormationModel>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/INIT/${this.stageService.Stage.Ident}`).subscribe
      ((result: QResult<PlanningFormationModel>) => {
        this.planningService.Filter = result.Value.DataFilter;
        this.planningService.ListeFormateurs = result.Value.DataFilter.Formateurs;
        this.planningService.ListeReservations = result.Value.ListeReservations;
        this.planningService.ListeLieux = result.Value.ListConvocationLocation;
        this.planningService.ListeBureaux = result.Value.ListBureaux;
        this.planningService.ListeDispo = result.Value.ListDispo;
        this.planningService.DateDebut = result.Value.DateDebut;
        this.planningService.DateFin = result.Value.DateFin;
        this.planningService.Objets = result.Value.AllObjects;
        this.isLoading = false;
        this.planningService.filterLoaded = true;
      });
    this.http.getHttp<QResult<string>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/GET_WORKSPACE_LOGGED_USER/0`).subscribe
      ((result: QResult<string>) => {
        this.planningService.idBureauUtilisateurConnecte = result.Value;
      });


    this.http.getHttp<QResult<boolean>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/Signature/API_SOWESIGN_EXIST/0/0`).subscribe(
      (result: QResult<boolean>) => {
        this.isApiSoWeSignExist = result.Value;

        this.indParam.GetParamsApplication([this.soWeSignURLportail, this.soWeSignQueovalSiteWS]).subscribe((result: ParamApplication[]) => {
          this.soWeSignURLportail = result[0];
          this.soWeSignQueovalSiteWS = result[1];
          if (this.soWeSignQueovalSiteWS.StrValue == '')
            this.soWeSignQueovalSiteWS.StrValue = this.indParam.AppParams.apiUrl;
        });

      });

    
  }

  /**
   * Mise à jour de la liste des formateurs pour le filtre
   * @param lstFormateur
   */
  public SetFilterFormateur(lstFormateur: Array<Person>): void {
    this.planningService.Filter.Formateurs = lstFormateur;
    setTimeout(() => { this.planningService.OnRefreshDisplay() });
  }

  /**
   * Fonction permettant de savoir s'il y a de nouvelles réservations
   **/
  public HasNewReserv(): boolean {
    return this.planningService.ListeReservations.filter(reserv => (!reserv.Ident || reserv.Ident == '0')).length > 0;
  }

  public ChangeSelect(): void {
    if (this.planningService.Filter.IndeterminateSelect) {
      if (!this.planningService.isSelectAll) {
        // pour forcer la déselection de tous
        this.planningService.isSelectAll = !this.planningService.isSelectAll;
        setTimeout(() => {
          this.planningService.isSelectAll = false;
        }, 0);
      }
      else {
        this.planningService.isSelectAll = !this.planningService.isSelectAll;
      }
    }
    else {
      this.planningService.isSelectAll = !this.planningService.isSelectAll;
    }
    this.planningService.Filter.IndeterminateSelect = false;

  }

  // #region SOWESIGN

  private getSelectedReservation():Array<string> {

    let lstReservToSend: Array<string> = [];
    for (var i = 0; i < this.planningService.ListeReservations.length; i++) {
      if (this.planningService.ListeReservations[i].IsSelected) {
        // Si c'est une réservation temporaire -> suppression manuellement dans la liste
        if (this.planningService.ListeReservations[i].Ident && this.planningService.ListeReservations[i].Ident != '0') {
          // Ajout à la liste qui va être supprimée en base
          lstReservToSend.push(this.planningService.ListeReservations[i].Ident);
        }
      }
    }
    return lstReservToSend;

  }

  // Synchronisation SoWeSign
  public GetSignatureSoWeSign() {
    this.isLoading = true;
    // Recuperation des presences et des signatures
    this.http.getHttp<QResult<string>>(`${this.soWeSignQueovalSiteWS.StrValue}api/Stage/Planning/Signature/GET_SIGNATURE_SOWESIGN/${this.stageService.Stage.Ident}/0`).subscribe(
      (result: QResult<string>) => {
        this.isLoading = false;
      });

  }

  public SendSignatureSoWeSign() {

    const lstReservToSend: Array<string> = this.getSelectedReservation();
    if (lstReservToSend.length > 0) {
      this.isLoading = true;
      const idReservations: string = lstReservToSend.join('|');

      // Envoi de la demande des signatures
      this.http.getHttp<QResult<Array<string>>>(`${this.soWeSignQueovalSiteWS.StrValue}api/Stage/Planning/Signature/SEND_SIGNATURE_SOWESIGN/${this.stageService.Stage.Ident}/${idReservations}`).subscribe(
        (result: QResult<Array<string>>) => {
          this.isLoading = false;
        });
    }
    else {
      this.toast.showInfoToast('Veuillez sélectionner au moins une réservation.');
    }

  }

  public SendRecoverySignatureSoWeSign() {    
    
    const lstReservToSend: Array<string> = this.getSelectedReservation();
    if (lstReservToSend.length > 0) {
      this.isLoading = true;
      const idReservations: string = lstReservToSend.join('|');

      // Envoi de la demande des signatures
      this.http.getHttp<QResult<string>>(`${this.soWeSignQueovalSiteWS.StrValue}api/Stage/Planning/Signature/SEND_RECOVERY_SIGNATURE_SOWESIGN/${this.stageService.Stage.Ident}/${idReservations}`).subscribe(
        (result: QResult<string>) => {
          this.isLoading = false;
        });
    }
    else {
      this.toast.showInfoToast('Veuillez sélectionner au moins une réservation.');
    }
  }



  public SetReferentielSoWeSign() {
    this.isLoading = true;
    // Envoi du referentiel apprenants formateurs stage reservations
    this.http.getHttp<QResult<string>>(`${this.soWeSignQueovalSiteWS.StrValue}api/Stage/Planning/Signature/SET_REFERENTIEL_SOWESIGN/${this.stageService.Stage.Ident}/0`).subscribe(
      (result: QResult<string>) => {
        this.isLoading = false;
      });

  }

    // #endregion SOWESIGN
}
